// A navigation hint only: authenticated routes still enforce access. Host-only so
// custom domains cannot reuse a destination cached on a different Orbit host.
const cookieName = "orbit-launch-v1"
const maxAge = 60 * 60 * 24

export function clearLaunchCache() {
	if (typeof document === "undefined") return
	try {
		document.cookie = `${cookieName}=; Path=/; Max-Age=0; SameSite=Lax`
	} catch {
		/* Cookies may be unavailable in embedded browsers. */
	}
}

export function readLaunchCache(userId: string, orgSlug?: string) {
	if (typeof document === "undefined") return null
	try {
		const raw = document.cookie
			.split("; ")
			.find((cookie) => cookie.startsWith(`${cookieName}=`))
			?.slice(cookieName.length + 1)
		if (!raw) return null
		const cached = JSON.parse(decodeURIComponent(raw))
		if (
			cached.userId !== userId ||
			typeof cached.expiresAt !== "number" ||
			cached.expiresAt <= Date.now() ||
			typeof cached.path !== "string" ||
			!/^\/[a-zA-Z0-9_-]+\/(?:me\/(?:inbox|issues)|[a-zA-Z0-9_-]+\/(?:home|queue|issues|kb))$/.test(
				cached.path
			)
		) {
			clearLaunchCache()
			return null
		}
		if (orgSlug && cached.path.split("/")[1] !== orgSlug) return null
		return cached.path as string
	} catch {
		clearLaunchCache()
		return null
	}
}

export function writeLaunchCache(userId: string, path: string | null) {
	if (typeof document === "undefined") return
	if (!path) {
		clearLaunchCache()
		return
	}
	const value = encodeURIComponent(
		JSON.stringify({ userId, path, expiresAt: Date.now() + maxAge * 1000 })
	)
	try {
		document.cookie = `${cookieName}=${value}; Path=/; Max-Age=${maxAge}; SameSite=Lax${location.protocol === "https:" ? "; Secure" : ""}`
	} catch {
		/* The API remains the fallback when cookies are unavailable. */
	}
}
